const initState = {
  resolutions: [],
  resolutionchats: [],
  singleResolution: [],
  isLoading: false,
  lastDocument: null,
  hasMoreDocument: false,
};

const resolutionCenterReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_RESOLUTION":
      return {
        ...state,
        resolutions: action.payload.data,
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_RESOLUTION_MORE":
      return {
        ...state,
        resolutions: [...state.resolutions, ...action.payload.data],
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_RESOLUTION_CHAT":
      return {
        ...state,
        resolutionchats: action.payload,
      };
    case "GET_SINGLE_RESOLUTION":
      return {
        ...state,
        singleResolution: action.payload,
      };
    case "SET_IS_LOADINGS":
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default resolutionCenterReducer;
